import { inject, Injectable } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class SessionTokenizerService {
  private router = inject(Router);

  public sessionQueryParamToken(): string {
    const windowUrl = window.location.href;
    const urlTree: UrlTree = this.router.parseUrl('/' + windowUrl.split('/'));
    const sessionId = urlTree.queryParams.sessionId;

    if (sessionId == null || sessionId === undefined) {
      return null;
    }

    return sessionId;
  }
}
